import { units } from '@m/alchemy-ui/theme';
import styled from 'styled-components';

export const Label = styled.label`
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: ${units(1)};
  padding: 0;
`;

export const Info = styled.div`
  margin: 8px 0 0 0;
  font:
    400 12px 'Nunito',
    helvetica,
    arial,
    sans-serif;
  color: #6b7587;
  cursor: initial;
`;

export const FieldsetGroup = styled.fieldset`
  list-style: none;
  padding: 0;
  margin: 0;
  clear: both;
`;

export const Item = styled.div`
  position: relative;
  margin-bottom: 20px;
`;

export const SrOnlyLegend = styled.legend`
  position: absolute;
  padding: 0;
  margin: -1px;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;

export const ErrorAlert = styled.p`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 16px 0;
  padding: 8px 12px;
  border-radius: 8px;
  background-color: #fae8e9;
  border: 1px solid #f3afb7;
  font:
    400 14px/1.3 'Nunito',
    helvetica,
    arial,
    sans-serif;
  color: #2c3548;
`;

export const OnboardGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;

  > * {
    flex: 1 1 calc(50% - 16px);
  }

  @media (max-width: 768px) {
    > * {
      flex: 1 1 100%;
    }
  }
`;

export const AlertInfo = styled.p`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 16px 0;
  padding: 8px 12px;
  border-radius: 8px;
  background-color: #eaf3ff;
  border: 1px solid #b9dfff;
  font:
    400 14px/1.3 'Nunito',
    helvetica,
    arial,
    sans-serif;
`;

export const Tag = styled.span<{ color: string }>`
  font:
    400 14px/1.3 'Nunito',
    helvetica,
    arial,
    sans-serif;
  color: ${({ color }) => '#' + color};
  margin-right: 4px;
`;
